import React from 'react';
import {
  Card,
  CardLeft,
  IconWrapper,
  Info,
  Label,
  SubArea,
  SubLabel,
  Value,
  ArrowIconWrapper,
} from './RecordCard.styled';
import {
  ArrowRightIcon,
} from '../../../../../../components/Icons';

export interface MealCardProps {
  /** アイコン要素 */
  icon: React.ReactNode;
  /** ラベル（例: 食事） */
  label: string;
  /** 主食 */
  stapleFood?: string;
  stapleFoodLabel?: string;
  /** 副食 */
  sideDish?: string;
  sideDishLabel?: string;
  /** 汁食 */
  soupFood?: string;
  soupFoodLabel?: string;
  /** クリックハンドラ */
  onClick?: () => void;
  /** クリック可能か */
  clickable?: boolean;
}

/**
 * MealCard（Molecule）
 * 食事情報を表示するカードコンポーネント
 */
export const MealCard: React.FC<MealCardProps> = ({
  icon,
  label,
  stapleFoodLabel,
  stapleFood,
  sideDishLabel,
  sideDish,
  soupFoodLabel,
  soupFood,
  onClick,
  clickable = true,
}) => {
  // キーボード操作対応
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (clickable && onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick();
    }
  };

  // アクセシビリティ用のラベルテキスト
  const ariaLabel = `${label}: ${stapleFood ? `${stapleFoodLabel}:${stapleFood}` : ''} ${sideDish ? `、${sideDishLabel}:${sideDish}` : ''} ${soupFood ? `、${soupFoodLabel}:${soupFood}` : ''} ${clickable ? '。詳細を表示' : ''}`;

  return (
    <Card
      onClick={clickable ? onClick : undefined}
      onKeyDown={handleKeyDown}
      tabIndex={clickable ? 0 : undefined}
      role={clickable ? 'button' : 'group'}
      aria-label={ariaLabel}
      $clickable={clickable}
    >
      <CardLeft>
        <IconWrapper aria-hidden="true">{icon}</IconWrapper>
        <Info>
          <Label>{label}</Label>
          {stapleFood && (
            <SubArea>
              <SubLabel>{stapleFoodLabel}</SubLabel>
              <Value $isSmallFontSize={true}>{stapleFood}</Value>
            </SubArea>
          )}
          {sideDish && (
            <SubArea>
              <SubLabel>{sideDishLabel}</SubLabel>
              <Value $isSmallFontSize={true}>{sideDish}</Value>
            </SubArea>
          )}
          {soupFood && (
            <SubArea>
              <SubLabel>{soupFoodLabel}</SubLabel>
              <Value $isSmallFontSize={true}>{soupFood}</Value>
            </SubArea>
          )}
        </Info>
      </CardLeft>
      {clickable && <ArrowIconWrapper><ArrowRightIcon /></ArrowIconWrapper>}
    </Card>
  );
};

export default MealCard;
